export default __webpack_public_path__ + "static/media/starken.a2f022fb.svg";